import React from "react";
import { observer, inject } from "mobx-react";
import { Row, Col, Table, Button, Form, ButtonGroup, DropdownButton, Dropdown, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RouteComponentProps, Link } from "react-router-dom";
import { STORE_CUSTOMER_ORDERS, SOURCES_ABTEKA } from "../../../../constants";
import { CustomerOrdersStore, CustomerOrderDetails, PositionStatusHistory } from "../../../../stores";
import { formatDate, formatMoney } from "../../../../common/Formatting";
import { LinkContainer } from "react-router-bootstrap";
import { runInAction } from "mobx";
import { wrapCheckbox } from "../../../../common/FormChangeWrapper";
import { StatusesHistoryModal } from "./StatusesHistoryModal";

interface IProps {
    history: any,
    [STORE_CUSTOMER_ORDERS]: CustomerOrdersStore
}

interface IState {
    orderGuid: string;
    orderDetails?: CustomerOrderDetails;
    positionStatusHistory: PositionStatusHistory[];
    statusHistoryModalIsOpened: boolean;
}


type Props = IProps & RouteComponentProps<{ orderGuid: string, backUrl: string }>;

@inject(STORE_CUSTOMER_ORDERS)
@observer
export class CustomerOrderDetailsPage extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        const orderGuid = this.props.match.params.orderGuid;
        this.state = {
            orderGuid: orderGuid,
            orderDetails: undefined,
            positionStatusHistory: [],
            statusHistoryModalIsOpened: false
        };
    }

    private customerOrdersStore = (this.props as any)[STORE_CUSTOMER_ORDERS] as CustomerOrdersStore;


    componentDidMount() {
        this.customerOrdersStore.loadOrder(this.state.orderGuid, (order: CustomerOrderDetails) => {
            this.setState({
                orderDetails: order
            })
        });
    }
    componentDidUpdate(prevProps: Props, prevState: IState, snapshot: any) {
        if (prevProps.match.params.orderGuid !== this.props.match.params.orderGuid) {
            const orderGuid = this.props.match.params.orderGuid;
            this.setState({
                orderGuid: orderGuid
            }, () => {
                this.customerOrdersStore.loadOrder(this.state.orderGuid, (order: CustomerOrderDetails) => {
                    this.setState({
                        orderDetails: order
                    })
                });
            });

        }
    }

    confirmOrder = () => {
        if (this.state.orderDetails != null)
            if (window.confirm(`Вы хотите подтвердить заказ №${this.state.orderDetails.orderNumber}. Продолжить?`))
                this.customerOrdersStore.saveConfirmation(this.state.orderDetails.orderGuid, (confirmationDate: Date, confirmationManager: string) => {
                    if (this.state.orderDetails != undefined) {
                        this.setState({
                            orderDetails: Object.assign({}, this.state.orderDetails, {
                                confirmationDate: confirmationDate,
                                confirmationManager: confirmationManager
                            })
                        });
                    }
                });
    }

    onPositionChecked = (index: number, checked: boolean) => {
        if (this.state.orderDetails != undefined) {
            const positions = this.state.orderDetails.positions.map((w, idx) => {
                if (idx === index)
                    return Object.assign({}, w, { isChecked: checked });
                return w;
            });
            this.setState({
                orderDetails: Object.assign({}, this.state.orderDetails, { positions: positions })
            })
        }
    }

    onAllPositionChecked = (checked: boolean) => {
        if (this.state.orderDetails != undefined) {
            const positions = this.state.orderDetails.positions.map((w, idx) => {
                return Object.assign({}, w, { isChecked: checked });
            });
            this.setState({
                orderDetails: Object.assign({}, this.state.orderDetails, { positions: positions })
            })
        }
    }

    openReturnModal = () => {
        if (this.state.orderDetails == undefined || this.state.orderDetails.positions.filter(w => w.isChecked && w.statusCode == 6/*Выдан*/).length == 0) {
            this.customerOrdersStore._rootStore.commonStore.notifyError("Не выбрано ни одной позиции со статусом 'Выдан'");
        }
    }

    toggleHiddenStatus = () => {
        if (this.state.orderDetails != null)
            if (window.confirm("Вы хотите изменить статус отображения заказа. Продолжить?"))
                this.customerOrdersStore.toggleHiddenStatus(this.state.orderDetails.orderGuid, (isHidden: boolean) => {
                    this.setState({
                        orderDetails: Object.assign({}, this.state.orderDetails, { isHidden: isHidden })
                    })
                })
    }

    loadStatusesHistory = (positionId: number) => {
        this.setState({
            positionStatusHistory: [],
            statusHistoryModalIsOpened: false
        })
        this.customerOrdersStore.loadStatusesHistory(positionId, (historyItems: PositionStatusHistory[]) => {
            this.setState({
                statusHistoryModalIsOpened: true,
                positionStatusHistory: historyItems
            })
        })
    }

    render() {
        const backUrl = this.props.match.params.backUrl != null && this.props.match.params.backUrl.length > 0 ?
            decodeURIComponent(this.props.match.params.backUrl)
            : "/sales/customerorders/";
        return this.state.orderDetails ? <div>
            <Row>
                <Col sm={12}>
                    <br />
                    <h3>
                        Заказ № {this.state.orderDetails.orderNumber}
                        <LinkContainer to={backUrl}>
                            <Link to={backUrl}>
                                <span style={{ fontSize: "1rem", marginLeft: "20px" }}>
                                    <FontAwesomeIcon icon="arrow-left" />
                                    Вернуться к списку заказов
                                </span>
                            </Link>
                        </LinkContainer>
                        {this.state.orderDetails != undefined && this.state.orderDetails.source == SOURCES_ABTEKA ? <Button size="sm" variant="warning" className="pull-right" onClick={this.openReturnModal}>Оформить возврат</Button> : []}
                    </h3>
                    <br />
                    <Row>
                        <Col sm="8">


                            <Table bordered size="sm">
                                <tbody>
                                    <tr>
                                        <th style={{ width: "200px" }}>Клиент</th>
                                        <td className="text-center" style={{ width: "300px" }}>
                                            {`${this.state.orderDetails.customerName || "фио не указано"}`} <br /> {`тел. ${this.state.orderDetails.customerPhone}`}
                                        </td>
                                        <th style={{ width: "200px" }}>Точка выдачи</th>
                                        <td className="text-center">{this.state.orderDetails.deliveryPointName}</td>
                                    </tr>
                                    <tr>
                                        <th>Подтверждение</th>
                                        <td className="text-center">{this.state.orderDetails.source !== SOURCES_ABTEKA
                                            || this.state.orderDetails.confirmationDate != undefined ? <small>
                                            Подтвержден {formatDate(this.state.orderDetails.confirmationDate as Date)}<br />
                                            {this.state.orderDetails.confirmationManager}
                                        </small> : <Button size="sm" variant="success" onClick={this.confirmOrder}>
                                            <FontAwesomeIcon icon="check" /> Подтвердить
                                        </Button>} </td>
                                        <th>Автозаказы</th>
                                        <td className="text-center">
                                            {this.state.orderDetails !== null && this.state.orderDetails.autocreatedOrders !== undefined ?
                                                this.state.orderDetails.autocreatedOrders.map((w, index) => <span style={{ padding: "0 5px" }} key={index}>
                                                    <LinkContainer key={index} to={`/sales/orderdetails/${w.orderGuid}/${backUrl}`}>
                                                        <Link target="_blank" to={`/sales/orderdetails/${w.orderGuid}/${backUrl}`}>{w.orderId}</Link>
                                                    </LinkContainer></span>) : []}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Дата заказа</th>
                                        <td className="text-center">{formatDate(this.state.orderDetails.dateCreate)}</td>
                                        <th>Родительский заказ</th>
                                        <td className="text-center">
                                            {this.state.orderDetails !== null && this.state.orderDetails.parentOrderId !== undefined ? <LinkContainer
                                                to={`/sales/orderdetails/${this.state.orderDetails.parentOrderGuid}/${backUrl}`}>
                                                <Link target="_blank" to={`/sales/orderdetails/${this.state.orderDetails.parentOrderGuid}/${backUrl}`}>
                                                    {this.state.orderDetails.parentOrderId}
                                                </Link>
                                            </LinkContainer> : []}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Тип оплаты</th>
                                        <td className="text-center">{this.state.orderDetails.typePayName}
                                            {!this.state.orderDetails.paymentLink.isNullOrEmpty() ? <div>
                                                <span>Ссылка на оплату:</span> <a target="_blank" href={this.state.orderDetails.paymentLink} rel="noreferrer">{this.state.orderDetails.paymentLink}</a>
                                            </div> : []}
                                        </td>
                                        <th> Комм. клиента</th>
                                        <td className="text-center">{this.state.orderDetails.customerComment}</td>
                                    </tr>
                                    <tr>
                                        <th>Тип доставки</th>
                                        <td className="text-center">{this.state.orderDetails.deliveryTypeName}</td>
                                        <th> Комм. менеджера</th>
                                        <td className="text-center">{this.state.orderDetails.managerComment}</td>
                                    </tr>
                                    <tr>
                                        <th>Сумма заказа</th>
                                        <td className="text-center">{this.state.orderDetails.orderSum} руб.</td>
                                        <th>Заказ скрыт</th>
                                        <td className="text-center">{this.state.orderDetails.isHidden ? <div>
                                            Да <Button onClick={this.toggleHiddenStatus} variant="primary" size="sm" className="pull-right">Убрать из скрытых</Button>
                                        </div> : <div>
                                            Нет <Button onClick={this.toggleHiddenStatus} variant="primary" size="sm" className="pull-right">Скрыть</Button>
                                        </div>}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                        <Col sm="4">
                            <Table size="sm" bordered striped>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Тип платежа</th>
                                        <th className="text-center">Дата</th>
                                        <th className="text-center">Сумма</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {(this.state.orderDetails.payments != undefined && this.state.orderDetails.payments.length > 0) ? this.state.orderDetails.payments.map((w, index) => <tr key={index}
                                        className={w.isIncoming ? "bg-success" : "bg-warning"}>
                                        <td className="text-center">{w.isCache ? <FontAwesomeIcon icon="money-bill-wave" title="Наличка" /> :
                                            <FontAwesomeIcon icon="credit-card" title="Безнал" />}</td>
                                        <td>{w.paymentTypeName}</td>
                                        <td className="text-center">{formatDate(w.dateCreate)}</td>
                                        <td className="text-center">{formatMoney(w.sum)}</td>
                                    </tr>) : <tr>
                                        <td colSpan={2}>Нет оплат</td>
                                    </tr>}
                                </tbody>
                            </Table>
                            {this.state.orderDetails.positions.filter(x => x.rejectCount > 0).length>0 ?
                                <Table size="sm" bordered striped>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Позиция</th>
                                            <th className="text-center">Дата отказа</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.orderDetails.positions.filter(x => x.rejectCount > 0).map((item, index) => 
                                            <tr key={index}>
                                                <td colSpan={2} style={{fontSize:"13px"} }>{item.brand + " " + item.article + " " + item.description}</td>
                                                <td className="text-center" style={{ color: "#ee1940" }}>{formatDate(item.rejectDate)}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                                : null
                            }
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row>
                <Col sm={12}>
                    <Table striped bordered className="table-xxs">
                        <thead>
                            <tr>
                                <th style={{ width: "50px", textAlign: "center" }}>
                                    <Form.Check type="checkbox" checked={this.state.orderDetails.positions.filter(w => !w.isChecked).length == 0} onChange={wrapCheckbox((fieldName: string, value: string, checked: boolean) => {
                                        this.onAllPositionChecked(checked);
                                    })} />
                                </th>
                                <th className="text-center">№</th>
                                <th className="text-center">Бренд</th>
                                <th className="text-center">Артикул</th>
                                <th>Описание</th>
                                <th className="text-center">Поставщик<br /><span style={{ color: "#ee1940" }}>Гарант.срок</span></th>
                                <th className="text-center">Ожидается</th>
                                <th className="text-center">Статус</th>
                                <th className="text-center">Количество</th>
                                {this.state?.orderDetails?.positions.some(x => x.rejectInfo != null) ? <th className="text-center">Причина</th> : null}
                                <th className="text-center">Цена</th>
                                <th className="text-center">Сумма</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.orderDetails.positions.map((item, index) => <tr key={index}>
                                <td className="text-center">
                                    <Form.Check type="checkbox" checked={item.isChecked} onChange={wrapCheckbox((fieldName: string, value: string, checked: boolean) => {
                                        this.onPositionChecked(index, checked);
                                    })} />
                                </td>
                                <td className="text-center">{index + 1}</td>
                                <td className="text-center">{item.brand}</td>
                                <td className="text-center">{item.article}</td>
                                <td>{item.description}</td>
                                <td className="text-center">
                                    {item.supCode != null ? `${item.supName}[${item.supCode}]` : item.supName}
                                    <br /><span style={{ color: "#ee1940" }}>{item.guaranteeDateString}</span></td>
                                <td className="text-center">
                                    {item.awaitedDateString}
                                </td>
                                <td className="text-center" style={{ backgroundColor: item.statusColor }}>
                                    {item.statusName}
                                    <FontAwesomeIcon icon="clock"
                                        title="История статусов"
                                        onClick={() => this.loadStatusesHistory(item.id)}
                                        style={{ marginLeft: "20px", cursor: "pointer" }} />
                                </td>
                                <td className="text-center">{item.count} {(item.rejectCount != null && item.rejectCount != item.count) ? <span style={{ color: "#ee1940" }}>{"(" + item.rejectCount + " отк.)"}</span> : null} </td>
                                {this.state?.orderDetails?.positions.some(x => x.rejectInfo != null) ? <td className="text-center">{item.rejectInfo}</td> : null}
                                <td className="text-center">{formatMoney(item.cost)} руб.</td>
                                <td className="text-center">{formatMoney(item.count * item.cost)} руб.</td>
                            </tr>)}
                        </tbody>
                    </Table>
                    
                </Col>
            </Row>
            <StatusesHistoryModal
                items={this.state.positionStatusHistory}
                isOpened={this.state.statusHistoryModalIsOpened}
                closeModal={() => { this.setState({ statusHistoryModalIsOpened: false }) }}
            />
        </div > : []
    }
}